/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

export interface RT {
  path: string;
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component?: React.FC<any>;
  redirect?: string;
  auth?: boolean;
  adminScopes?: string[];
  dividerTitle?: string; // 메뉴 위에 Divider title
  hidden?: boolean;
}

export interface RouteTable extends RT {
  subs: RouteTable[];
  parents: RouteTable[];
  fullPath: string;
  menu?: boolean;
}
export interface MainRouteTable extends RouteTable {
  icon: React.FC<any>;
}

export function createMainMenu({
  path,
  fullPath,
  title,
  component,
  redirect,
  auth,
  adminScopes,
  icon,
  subs = [],
  dividerTitle,
  hidden = false,
}: RT & {
  fullPath?: string;
  subs?: RouteTable[];
  icon: React.FC<any>;
}): MainRouteTable {
  return {
    ...createMenu({
      path: path,
      fullPath: fullPath,
      title,
      component,
      redirect,
      auth,
      adminScopes,
      subs,
      hidden,
    }),
    icon,
    dividerTitle,
  };
}
export function createMenu({
  path,
  fullPath,
  title,
  component,
  redirect,
  auth,
  adminScopes,
  subs = [],
  hidden = false,
}: RT & {
  fullPath?: string;
  subs?: RouteTable[];
}): RouteTable {
  return {
    ...createRoute({
      path,
      fullPath,
      title,
      component,
      redirect,
      auth,
      adminScopes,
      subs,
      hidden,
    }),
    menu: true,
  };
}
export function createRoute({
  path,
  fullPath,
  title,
  component,
  redirect,
  auth,
  adminScopes,
  subs = [],
  hidden = false,
}: RT & {
  fullPath?: string;
  subs?: RouteTable[];
}): RouteTable {
  return {
    path,
    title,
    component,
    redirect: redirect,
    auth: auth !== undefined ? auth : true,
    adminScopes: adminScopes !== undefined ? adminScopes : [],
    fullPath: fullPath ? fullPath : '',
    parents: [],
    subs,
    hidden,
  };
}

export function createSinglePage({
  path,
  fullPath,
  title,
  component,
  auth,
  adminScopes,
}: RT & {
  fullPath: string;
}): RouteTable {
  return {
    path,
    title,
    component,
    auth,
    adminScopes,
    subs: [],
    parents: [],
    fullPath,
  };
}

export function spreadAndFillTheRest(
  routeTable: RouteTable,
  parentTable: RouteTable
): RouteTable[] {
  const parentFullPath = parentTable.fullPath;
  const subPath = routeTable.path;
  routeTable.fullPath =
    parentFullPath.endsWith('/') && subPath.startsWith('/')
      ? parentFullPath.substring(0, parentFullPath.length - 1) + subPath
      : parentFullPath + subPath;
  if (
    parentTable.adminScopes &&
    parentTable.adminScopes.length > 0 &&
    (!routeTable.adminScopes || routeTable.adminScopes.length === 0)
  ) {
    routeTable.adminScopes = [...parentTable.adminScopes];
  }
  routeTable.parents = [...parentTable.parents, parentTable];
  if (!routeTable.component && !routeTable.redirect && routeTable.subs.length > 0) {
    routeTable.redirect = routeTable.fullPath + routeTable.subs[0].path;
  }
  const spreadSubRouteTables = routeTable.subs.flatMap((sub) =>
    spreadAndFillTheRest(sub, routeTable)
  );
  return [...spreadSubRouteTables, routeTable];
}

export default createMainMenu;
